export default __webpack_public_path__ + "static/media/broken-shield.45a71719.png";